module.exports = __webpack_public_path__ + "staticVue/img/user-icon.81901c2d.png";